import { render, staticRenderFns } from "./WorkKnowledgeDialog.vue?vue&type=template&id=3bb85460&"
import script from "./WorkKnowledgeDialog.vue?vue&type=script&lang=js&"
export * from "./WorkKnowledgeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports